import React from 'react';
import MssTooltip from '../MssTooltip';

export const FieldRequiredMark = ({ label }) => (
  <MssTooltip title={`${label} is required`} placement="top">
    <span className="mss__requiredMark">*</span>
  </MssTooltip>
);
